import { normalizeContact } from './deal-values.js';

export function normalizeSearch(value) {
    return String(value ?? '').normalize('NFKC').toLocaleLowerCase('ru-RU').replace(/ё/g, 'е').replace(/\s+/g, ' ').trim();
}

export function matchesSearch(query, values) {
    const terms = normalizeSearch(normalizeContact(query)).split(' ').filter(Boolean);
    const fields = values.map(value => normalizeSearch(normalizeContact(value)));
    return terms.every(term => fields.some(value => value.includes(term)));
}

export async function loadAllPages(fetchPage, pageSize = 100) {
    const rows = [], ids = new Set();
    for (let skip = 0; ; skip += pageSize) {
        const page = await fetchPage(skip, pageSize);
        if (!Array.isArray(page)) throw new Error('Некорректный ответ списка');
        let added = 0;
        for (const row of page) if (!ids.has(row.id)) { ids.add(row.id); rows.push(row); added++; }
        if (page.length < pageSize) return rows;
        if (!added) throw new Error('Не удалось загрузить следующую страницу списка');
    }
}

export function filterTransactions(rows, {type = '', account = '', from = '', to = ''} = {}) {
    // Date inputs describe the user's local calendar day, not midnight in UTC.
    const start = from ? new Date(from + 'T00:00:00').getTime() : -Infinity;
    const end = to ? new Date(to + 'T23:59:59.999').getTime() : Infinity;
    return rows.filter(row => (!type || row.type === type)
        && (!account || row.from_account_id === account || row.to_account_id === account)
        && (!from && !to || new Date(row.created_at).getTime() >= start && new Date(row.created_at).getTime() <= end));
}
